import BaseModel from './BaseModel';
import FileModel from './FileModel';
import UserModel from './UserModel';
import CompanyModel from './CompanyModel';
import OptionModel from './OptionModel';
import { TaskChecklistModel } from './TaskChecklistModel';

export default class AbstractTaskTemplateModel extends BaseModel {
  constructor(data, args) {
    super();

    // why js no have abstract classes :(
    if (this.constructor.name === 'AbstractTaskTemplateModel') {
      throw new Error('AbstractTaskTemplateModel is an abstract class and cannot be instantiated directly.');
    }
    this.init(data || {});
    this.categoryRequired = args?.categoryRequired || false;
  }

  init(data) {
    this.id = data.id || 0;
    this.name = data.name || '';
    this.description = data.description || '';
    this.description_headline = data.description_headline || '';
    this.category = data.category ? new OptionModel(data.category) : null;
    this.user = data.user ? new UserModel(data.user) : null;
    this.company = data.company ? new CompanyModel(data.company) : null;
    this.attachments = (data.attachments || []).map(f => new FileModel(f));
    this.archived = 'archived' in data ? data.archived : false;
    this.deleted = 'deleted' in data ? data.deleted : false;
    this.created = data.created ? new Date(data.created) : null;
    this.updated = data.updated ? new Date(data.updated) : null;
    this.checklists = (data.checklists || []).map(c => new TaskChecklistModel(c, { persisted: false }));
  }

  get categoryName() {
    return this.category?.name || '';
  }

  get checklistCount() {
    return this.checklists?.length;
  }
}
